import React from "react";
import { Select, MenuItem } from "@mui/material";

export default function ColorSelectInput({ register, index, defaultValue }) {
  return (
    <Select
      sx={{ width: "100%", height: "48px" }}
      label={""}
      id="demo-simple-select"
      defaultValue={defaultValue}
      {...register(`GROUP_COLOR_${index}`)}
    >
      <MenuItem value={"RED"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "red",
            borderRadius:'50%',
            display: "inline-block",
            marginRight: "10px",
          }}
        ></div>
        Red
      </MenuItem>
      <MenuItem value={"PURPLE"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "purple",
            display: "inline-block",
            marginRight: "10px",
            borderRadius:'50%'
          }}
        ></div>
        Purple
      </MenuItem>
      <MenuItem value={"ORANGE"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "orange",
            display: "inline-block",
            marginRight: "10px",
            borderRadius:'50%'
          }}
        ></div>
        Orange
      </MenuItem>
      <MenuItem value={"BLUE"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "blue",
            display: "inline-block",
            marginRight: "10px",
            borderRadius:'50%'
          }}
        ></div>
        Blue
      </MenuItem>
      <MenuItem value={"GREEN"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "green",
            display: "inline-block",
            marginRight: "10px",
            borderRadius:'50%'
          }}
        ></div>
        Green
      </MenuItem>
			<MenuItem value={"BLACK"}>
        <div
          style={{
            height: "10px",
            width: "10px",
            background: "black",
            borderRadius:'50%',
            display: "inline-block",
            marginRight: "10px",
          }}
        ></div>
        Black
      </MenuItem>
    </Select>
  );
}
